"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const logs_1 = require("@ledgerhq/logs");
const errors_1 = require("@ledgerhq/errors");
const cache_1 = require("./cache");
const errors_2 = require("./errors");
const utils_1 = require("./wallet-btc/utils");
const factory_1 = __importDefault(require("./wallet-btc/crypto/factory"));
const base_1 = require("./wallet-btc/crypto/base");
const getTransactionStatus = (a, t) => __awaiter(void 0, void 0, void 0, function* () {
    const errors = {};
    const warnings = {};
    const useAllAmount = !!t.useAllAmount;
    const { recipientError, recipientWarning } = yield (0, cache_1.validateRecipient)(a.currency, t.recipient);
    if (recipientError) {
        errors.recipient = recipientError;
    }
    if (recipientWarning) {
        warnings.recipient = recipientWarning;
    }
    // Safeguard before Taproot activation
    if (t.recipient && !errors.recipient && a.currency.id === "bitcoin" && a.blockHeight <= 709632) {
        const isTaproot = yield (0, cache_1.isTaprootRecipient)(a.currency, t.recipient);
        if (isTaproot) {
            errors.recipient = new errors_2.TaprootNotActivated();
        }
    }
    let txInputs;
    let txOutputs;
    let estimatedFees = new bignumber_js_1.BigNumber(0);
    const { opReturnData } = t;
    if (!t.feePerByte) {
        errors.feePerByte = new errors_1.FeeNotLoaded();
    }
    else if (t.feePerByte.eq(0)) {
        errors.feePerByte = new errors_1.FeeRequired();
    }
    else if (t.recipient && !errors.recipient) {
        yield (0, cache_1.calculateFees)({
            account: a,
            transaction: t,
        }).then(res => {
            txInputs = res.txInputs;
            txOutputs = res.txOutputs;
            estimatedFees = res.fees;
        }, error => {
            if (error.name === "NotEnoughBalance") {
                errors.amount = error;
            }
            else if (error.name === "DustLimit") {
                errors.dustLimit = error;
            }
            else {
                throw error;
            }
        });
    }
    const sumOfInputs = (txInputs || []).reduce((sum, input) => sum.plus(input.value), new bignumber_js_1.BigNumber(0));
    const sumOfChanges = (txOutputs || [])
        .filter(o => o.isChange)
        .reduce((sum, output) => sum.plus(output.value), new bignumber_js_1.BigNumber(0));
    if (txInputs) {
        (0, logs_1.log)("bitcoin", `${txInputs.length} inputs, sum: ${sumOfInputs.toString()}`);
    }
    if (txOutputs) {
        (0, logs_1.log)("bitcoin", `${txOutputs.length} outputs, sum of changes: ${sumOfChanges.toString()}`);
    }
    const totalSpent = sumOfInputs.minus(sumOfChanges);
    const amount = useAllAmount ? totalSpent.minus(estimatedFees) : t.amount;
    (0, logs_1.log)("bitcoin", `totalSpent ${totalSpent.toString()} amount ${amount.toString()}`);
    if (!errors.amount && !amount.gt(0)) {
        errors.amount = useAllAmount ? new errors_1.NotEnoughBalance() : new errors_1.AmountRequired();
    }
    if (amount.gt(0) && estimatedFees.times(10).gt(amount)) {
        warnings.feeTooHigh = new errors_1.FeeTooHigh();
    }
    if (t.feePerByte) {
        const txSize = Math.ceil(estimatedFees.toNumber() / t.feePerByte.toNumber());
        const crypto = (0, factory_1.default)(a.currency.id);
        const dustAmount = (0, utils_1.computeDustAmount)(crypto, txSize);
        if (amount.gt(0) && amount.lt(dustAmount)) {
            errors.dustLimit = new errors_1.DustLimit();
        }
    }
    if (opReturnData && opReturnData.length > base_1.OP_RETURN_DATA_SIZE_LIMIT) {
        errors.opReturnSizeLimit = new errors_1.OpReturnDataSizeLimit();
    }
    return {
        errors,
        warnings,
        estimatedFees,
        amount,
        opReturnData: opReturnData === null || opReturnData === void 0 ? void 0 : opReturnData.toString(),
        totalSpent,
        txInputs,
        txOutputs,
    };
});
exports.default = getTransactionStatus;
//# sourceMappingURL=js-getTransactionStatus.js.map